import { ShaderDataType } from "../../DriverDesign/RenderDevice/ShaderData";
export class WebGLUniformBufferDescriptor {
    get byteLength() {
        return this._byteLength;
    }
    constructor(name) {
        this._currentLength = 0;
        this._byteLength = 0;
        this._maxAlignment = 4;
        this.name = name;
        this.uniforms = new Map();
    }
    alignmentPadding(alignment) {
        let pointer = this._currentLength;
        let endPadding = pointer % alignment;
        if (endPadding != 0) {
            endPadding = alignment - endPadding;
            this._currentLength += endPadding;
            this._byteLength += endPadding * 4;
        }
        this._maxAlignment = Math.max(this._maxAlignment, alignment);
    }
    addUniformItem(index, size, alignStride, arraySize, tsc) {
        if (arraySize > 0) {
            alignStride = alignStride > 4 ? alignStride : 4;
            this.alignmentPadding(4);
            let arrayStride = arraySize * alignStride;
            let view;
            let uniform = {
                index: index,
                view: view,
                size: size,
                alignStride: alignStride,
                offset: this._currentLength * 4,
                dataView: tsc,
                viewByteLength: tsc.BYTES_PER_ELEMENT * arrayStride,
                arrayLength: arraySize,
            };
            this.uniforms.set(index, uniform);
            this._currentLength += arrayStride;
            this._byteLength += uniform.viewByteLength;
        }
        else {
            this.alignmentPadding(size <= 2 ? size : 4);
            let view;
            let uniform = {
                index: index,
                view: view,
                size: size,
                alignStride: alignStride,
                offset: this._currentLength * 4,
                dataView: tsc,
                viewByteLength: tsc.BYTES_PER_ELEMENT * alignStride,
                arrayLength: 0,
            };
            this.uniforms.set(index, uniform);
            this._currentLength += size;
            this._byteLength += size * tsc.BYTES_PER_ELEMENT;
        }
    }
    addUniform(index, type, arraySize = 0) {
        let alignStride = 0;
        switch (type) {
            case ShaderDataType.Int:
            case ShaderDataType.Bool:
                alignStride = 1;
                this.addUniformItem(index, 1, alignStride, arraySize, Int32Array);
                break;
            case ShaderDataType.Float:
                alignStride = 1;
                this.addUniformItem(index, 1, alignStride, arraySize, Float32Array);
                break;
            case ShaderDataType.Vector2:
                alignStride = 2;
                this.addUniformItem(index, 2, alignStride, arraySize, Float32Array);
                break;
            case ShaderDataType.Vector3:
                alignStride = 3;
                this.addUniformItem(index, 3, alignStride, arraySize, Float32Array);
                break;
            case ShaderDataType.Vector4:
            case ShaderDataType.Color:
                alignStride = 4;
                this.addUniformItem(index, 4, alignStride, arraySize, Float32Array);
                break;
            case ShaderDataType.Matrix3x3:
                alignStride = 12;
                this.addUniformItem(index, 12, alignStride, arraySize, Float32Array);
                break;
            case ShaderDataType.Matrix4x4:
                alignStride = 16;
                this.addUniformItem(index, 16, alignStride, arraySize, Float32Array);
                break;
            case ShaderDataType.Buffer:
                console.log("ShaderDataType.Buffer not support");
                break;
            case ShaderDataType.Texture2D:
            case ShaderDataType.Texture3D:
            case ShaderDataType.TextureCube:
            case ShaderDataType.Texture2DArray:
            case ShaderDataType.None:
            default:
                break;
        }
    }
    finish(alignment = 0) {
        alignment = alignment > this._maxAlignment ? alignment : this._maxAlignment;
        this._maxAlignment = alignment;
        this.alignmentPadding(alignment);
    }
    clone() {
        let descriptor = new WebGLUniformBufferDescriptor(this.name);
        this.cloneTo(descriptor);
        return descriptor;
    }
    cloneTo(destObject) {
        this.uniforms.forEach(uniform => {
            destObject.addUniformItem(uniform.index, uniform.size, uniform.alignStride, uniform.arrayLength, uniform.dataView);
        });
        destObject.finish(this._maxAlignment);
    }
    destroy() {
        this.uniforms.clear();
    }
}
